module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA3UlEQVRYR93XsQ0CMQyF4ecRjlGORYAS6BBTITqgBBbhRuFGMApISBQQJ35WJFLf6f+UIk4EjZc07iMPUEh/6ZYJOszHEwTKRGcB/blbCeTwjAr2t9l9y0SUAQIQWQAUMr1OdlBs3ltP3Ik8IFUDETZAIMIOCEKUAQIQ5QAyog5ARNQDSAgfgIDwA5wIDuALQqHrYTEefw2vPwE4jmr/Djjir+HqWc64D0CI1wNI8ToAMV4OIMfLAAFxOyAobgMExk2Aj3dBi2t584dJupI3fZp5TmrLv75ZYClkvnkA+QPWIXajYSEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/new_open_jt@2x.png
// module id = p0xb
// module chunks = 1